import { render, staticRenderFns } from "./inputEdit.vue?vue&type=template&id=453c6056&scoped=true"
import script from "./inputEdit.vue?vue&type=script&lang=js"
export * from "./inputEdit.vue?vue&type=script&lang=js"
import style0 from "./inputEdit.vue?vue&type=style&index=0&id=453c6056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c6056",
  null
  
)

export default component.exports